module.exports = __webpack_public_path__ + "media/images/logomerieux-89533bdf.png";